import { createSlice, PayloadAction, nanoid } from '@reduxjs/toolkit';

// Define the kbItem interface
export interface kbItem {
  id: string;
  fileName: string;
  type?: 'pdf' | 'url' | 'txt' | 'docx' | 'csv' | 'json';
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error?: string | null;
}

interface KbState {
  items: kbItem[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: KbState = {
  items: [],
  status: 'idle',
  error: null,
};

const kbSlice = createSlice({
  name: 'kb',
  initialState,
  reducers: {
    addKbItem: (state, action: PayloadAction<Omit<kbItem, 'id'>>) => {
      const { fileName, type, status, error = null } = action.payload;
      const newItem = {
        id: nanoid(),
        fileName,
        type,
        status,
        error
      };
      
      switch (status) {
        case 'succeeded':
          state.items.push(newItem);
          break;
        case 'failed':
          state.error = error;
          break;
        default:
          console.error(`Unhandled status: ${status} for item: ${fileName}`);
      }
      state.status = status;
    },

    setKbStatus: (state, action: PayloadAction<'idle' | 'loading' | 'succeeded' | 'failed'>) => {
      state.status = action.payload;
      if (action.payload !== 'failed') {
        state.error = null;
      }
    },

    resetKbItems: (state) => {
      state.items = [];
      state.status = 'idle';
      state.error = null;
    },

    deleteKbItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
  },
});

export const { addKbItem, setKbStatus, resetKbItems, deleteKbItem } = kbSlice.actions;
export default kbSlice.reducer;
